// extracted by mini-css-extract-plugin
module.exports = {"root":"_125580","cardGradient":"_e665bf","title":"_842bc9","subTitle":"_522686","usersContainer":"_673e81"};